import { useCountries } from "@/context/CountriesContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const CountryStatus = ({ c, need = "selling" }) => {
  const open = need === "delivery" ? c?.delivery_enabled : c?.selling_enabled;
  return open
    ? <span className="rounded-full bg-green-100 px-2 py-0.5 text-[10px] font-bold text-green-800">Disponible</span>
    : <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-bold text-gray-600">Bientôt</span>;
};

export const CountrySelect = ({ value, onChange, testid = "country-select", need = "selling" }) => {
  const { countries } = useCountries();
  return (
    <Select value={value || "SN"} onValueChange={onChange}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="Choisir un pays" /></SelectTrigger>
      <SelectContent className="max-h-72">
        {countries.map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid={`${testid}-option-${c.code}`}>
            <span className="flex items-center gap-2">{c.name} <span className="text-xs text-gray-400">{c.currency_label} ({c.currency})</span><CountryStatus c={c} need={need} /></span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const CountryNotice = ({ code, need = "selling" }) => {
  const { byCode } = useCountries();
  const c = byCode[code];
  if (!c || (need === "delivery" ? c.delivery_enabled : c.selling_enabled)) return null;
  return (
    <p data-testid="country-soon-notice" className="text-xs text-amber-700">
      {need === "delivery" ? "La livraison" : "La vente et la livraison"} ne sont pas encore ouvertes pour ce pays ({c.name}). Bientôt disponible.
    </p>
  );
};
